/**
 * The Datadog `env` a build reports under (DHT-4705).
 *
 * Only a release build pointed at prod-au is `production`. A `__DEV__` Metro
 * or webpack build pointed at prod-au used to report as `production` too, so a
 * developer's dev-only warnings (Recoil's "Duplicate atom key" on every Fast
 * Refresh, Metro's "Could not load bundle") were counted as production errors.
 */
export const telemetryEnv = (
  environment: string,
  isDev: boolean,
): "production" | "development" =>
  !isDev && environment === "prod-au" ? "production" : "development";
